import { useFormContext } from 'react-hook-form';
import { Card } from '@shared/ui';
import { getErrorMessages } from '@src/library/helpers/forms/getErrorMessages';
import * as st from './styles.module.scss';
import { Period } from './ui/period';

export const EditorAccess = (): JSX.Element => {
  const {
    formState: { errors },
  } = useFormContext();

  const errorMessage = getErrorMessages(errors, ['access_duration']).join(' ');

  return (
    <fieldset className={st.access}>
      <div className={st.access__header}>
        <h3>Доступ</h3>
        <p>{errorMessage}</p>
      </div>
      <Card className={st.card}>
        <div className={st.access__dropdown}>
          <Period />
        </div>
        <p className={st.access__subtitle}>Доступность видеопрограммы после ее оплаты</p>
      </Card>
    </fieldset>
  );
};
